export const USER_CURRICULUM_STATUS = {
    NOT_JOIN: 0,
    JOINING: 1,
    COMPLETED: 2
};

export const USER_CURRICULUM_STATUS_CONFIG = {
    [USER_CURRICULUM_STATUS.NOT_JOIN]: {
        label: '未受検',
        value: USER_CURRICULUM_STATUS.NOT_JOIN
    },
    [USER_CURRICULUM_STATUS.JOINING]: {
        label: '受検中',
        value: USER_CURRICULUM_STATUS.JOINING
    },
    [USER_CURRICULUM_STATUS.COMPLETED]: {
        label: '受検完了',
        value: USER_CURRICULUM_STATUS.COMPLETED
    }
};

export const APPLY_CERT_STATUS = {
    NOT_APPLY: 0,
    APPLIED: 1
}

export const APPLY_CERT_STATUS_CONFIG = {
    [APPLY_CERT_STATUS.NOT_APPLY]: {
        label: '単位申請中',
        value: APPLY_CERT_STATUS.NOT_APPLY
    },
    [APPLY_CERT_STATUS.APPLIED]: {
        label: '単位取得済',
        value: APPLY_CERT_STATUS.APPLIED
    }
};